import { render, staticRenderFns } from "./CalendarStarFourPoints.vue?vue&type=template&id=c4dbcdc4"
import script from "./CalendarStarFourPoints.vue?vue&type=script&lang=js"
export * from "./CalendarStarFourPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports